import { ChangeDetectionStrategy, Component } from "@angular/core";

import { RouterModule } from "@angular/router";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";
import {
  DropdownItem,
  IButtonDirective,
  IDropdownMenuComponent,
  IDropdownMenuItemDirective,
  IDropdownMenuSeparatorComponent,
  IDropdownMenuTriggerDirective,
  IIcon,
  IIconComponent,
  ITooltipDirective,
} from "@front/m19-ui";

export interface GridDropdownParams {
  label: string;
  icon: IIcon;
  items: DropdownItem[][];
  disabled?: boolean;
  tooltip?: string;
}

@Component({
  selector: "IGridDropdown",
  imports: [
    RouterModule,
    IButtonDirective,
    IDropdownMenuComponent,
    IDropdownMenuItemDirective,
    IDropdownMenuTriggerDirective,
    IDropdownMenuSeparatorComponent,
    ITooltipDirective,
    IIconComponent,
  ],
  templateUrl: "./grid-dropdown.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridDropdownComponent implements ICellRendererAngularComp {
  params!: GridDropdownParams;

  agInit(params: ICellRendererParams & GridDropdownParams): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}
